import { render, staticRenderFns } from "./reborrowCountForSubmit.vue?vue&type=template&id=185df08b&scoped=true&"
import script from "./reborrowCountForSubmit.vue?vue&type=script&lang=js&"
export * from "./reborrowCountForSubmit.vue?vue&type=script&lang=js&"
import style0 from "./reborrowCountForSubmit.vue?vue&type=style&index=0&id=185df08b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185df08b",
  null
  
)

export default component.exports